import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { BaseAPIService } from './base-api.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private api: ApiService) { }

  get(): Promise<any[]> {
    throw new Error('Method not implemented.');
  }

  getById(id: number): Promise<any> {
    throw new Error('Method not implemented.');
  }

  getByUUID(uuid: string): Promise<any> {
    throw new Error('Method not implemented.');
  }

  post(model: any): Promise<any> {
    return this.api.post(`Login/register`, model).toPromise();
  }

  put(model: any): Promise<any> {
    throw new Error('Method not implemented.');
  }

  delete(): Promise<any> {
    return this.api.delete(`User`).toPromise();
  }

}
